import { memo, MouseEvent, useCallback } from 'react'
import tw from 'twin.macro'
import { Typography } from '@mui/material'
import { colors } from 'src/theme'
import { TabsSelectorOption } from './types'
import { CaretDownMinor } from '@shopify/polaris-icons'

interface Props<V extends string> extends TabsSelectorOption<V> {
  showArrow?: boolean
  selected?: boolean
  onSelect: (e: MouseEvent<HTMLDivElement>, value: V) => void
}

const TabsSelectorItemComponent = <V extends string>({
  label,
  value,
  count,
  showDot,
  selected,
  showArrow,
  onSelect,
}: Props<V>) => {
  const handleSelect = useCallback(
    (e: MouseEvent<HTMLDivElement>) => {
      onSelect(e, value)
    },
    [value, onSelect],
  )

  return (
    <div css={tw`cursor-pointer mx-4 max-w-[240px] hover:opacity-70`} onClick={handleSelect}>
      <div css={tw`flex items-center`}>
        {showDot && <div css={tw`w-2 h-2 rounded-full bg-[#7F00FF] mr-2`} />}
        <Typography
          variant="subtitle1"
          fontWeight={500}
          color={!selected ? colors.SHADES_GREY_500 : undefined}
          css={tw`whitespace-nowrap overflow-hidden text-ellipsis`}
        >
          {label}
        </Typography>
        {!!count && (
          <div
            css={[tw`rounded-[10px] bg-[#DAD9E0] px-2 py-0.5 ml-2`, !selected && tw`bg-[#EDEDED]`]}
          >
            <Typography
              color={!selected ? colors.SHADES_GREY_500 : undefined}
              fontWeight={500}
              variant="subtitle2"
            >
              {count}
            </Typography>
          </div>
        )}
        {showArrow && (
          <div css={tw`w-5 h-5`}>
            <CaretDownMinor width={20} />
          </div>
        )}
      </div>
      <div css={[tw`h-[3px] bg-black w-full mt-3 rounded-t-lg`, !selected && tw`opacity-0`]} />
    </div>
  )
}

export const TabsSelectorItem = memo(TabsSelectorItemComponent) as typeof TabsSelectorItemComponent
